module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMjUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNLTUgMWgyM3YyM0gtNXoiLz48cGF0aCBzdHJva2U9IiM1QzVENUYiIHN0cm9rZS13aWR0aD0iMiIgZD0ibTEgMSAxMS41IDExLjVMMSAyNCIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/right.svg
// module id = 8mTn
// module chunks = 40